import axios from '../config.js';
const resource = '/pms/patient/search';

export default {
  get(caseNumber='', memberIdNumber='') {
    console.log({ caseNumber, memberIdNumber });
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    const params = new URLSearchParams();
    if (caseNumber)  params.append('first_name', caseNumber);
    if (memberIdNumber) params.append('last_name', memberIdNumber);
    return axios.get(resource, { params: params });
  },
};